import React, { useState, useContext, useEffect } from "react";

import { Back, Hero, LinearGradient, Next } from "../../../../components";

import { Container, Section, NavigateButtons } from "./styles";
import { DataUserContext, NavigateButtonsContext } from "../../../Criare";

import nameValidator from "../../../../utils/name-validation";
import { ThemeContext, DefaultTheme } from "styled-components";
import { sendPersonalData } from "../../../../services/data-service/api";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";

const Question03: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { setUserName, token } = useContext(DataUserContext);

  const [requirementsFulfilled, setRequirementsFulfilled] =
    useState<boolean>(false);

  const [name, setName] = useState<string>("");
  const [error, setError] = useState<number>(0);

  useEffect(() => {
    if (nameValidator(name)) setRequirementsFulfilled(true);
    else setRequirementsFulfilled(false);
  }, [name]);

  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);

  useEffect(() => {
    if (_theme.steps) setTheme(_theme);
  }, [_theme]);

  function submit() {
    if (requirementsFulfilled) {
      setUserName(name);
      sendPersonalData({ nome: name }, token);
      next(5);
    } else {
      setError((prevState) => prevState + 1);
    }
  }

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 4);
  }, []);

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_dados_pessoais.propriedades.imagens.etapa_dados_pessoais_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_dados_pessoais.propriedades.banner.subtituloBanner"
            )}
          />

          <Section>
            <p>
              {can(
                theme,
                "theme.steps.etapa_dados_pessoais.propriedades.conteudo.titulo"
              )}
            </p>
            <input
              placeholder="Qual seu nome completo?"
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
          </Section>

          <NavigateButtons>
            <Back criare onClick={() => next(HistoryPages.getLastPage())} />
            <Next criare onClick={submit} animationTrigger={error} />
          </NavigateButtons>

          <LinearGradient />
        </Container>
      )}
    </>
  );
};

export default Question03;
